export const DASHBOARD_VIEW_NAME = "Product Dashboard View";
export const URL_PATTERN = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*(\?[^\s]*)?$/;
 export const ANALYTICAL_PRODUCT = "analyticalProduct";

export const REPORT_MAP = {
  "data-quality": 1,
  "data-traffic-light": 2,
  "code-quality": 3,
  "sfu-usage": 4,
  "cost-monitoring": 5,
  "platform-kpi": 6,
  "product-usage": 7,
  "product-view": 8,
};
export const BUSINESS_FUNCTION_OPTIONS = [
  { value: "mw", label: "MW" },
  { value: "health", label: "Health and Wellness" },
  { value: "immersive", label: "Immersive Experience" },
];
export const issueOptions = [
    { value: "Incorrect Definition", desc: "The definition contains errors or inaccuracies" },
    { value: "Outdated", desc: "The information is no longer current or relevant" },
    { value: "Needs Review", desc: "The term should be reviewed by a steward" },
    { value: "Missing Information", desc: "Important details are missing from the definition" },
];